import React from "react";
import { Skeleton } from "@/components/ui/skeleton";

// Card grid skeleton used across discovery routes.
export function LoadingState({ count = 6, testId = "loading-state" }) {
  return (
    <div
      data-testid={testId}
      className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3"
    >
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="space-y-3">
          <Skeleton className="aspect-[4/3] w-full rounded-2xl" />
          <Skeleton className="h-5 w-3/4 rounded-md" />
          <Skeleton className="h-4 w-1/2 rounded-md" />
          <div className="flex items-center gap-2 pt-1">
            <Skeleton className="h-7 w-7 rounded-full" />
            <Skeleton className="h-4 w-24 rounded-md" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default LoadingState;
